export interface GeoFix {
  latitude: number
  longitude: number
  accuracyMeters: number
  altitudeMeters?: number | null
  recordedAt: number
}

export interface GeolocationCapability {
  watch(onFix: (fix: GeoFix) => void, onError: (error: Error) => void, options?: PositionOptions): () => void
}

export class WebGeolocation implements GeolocationCapability {
  watch(onFix: (fix: GeoFix) => void, onError: (error: Error) => void, options?: PositionOptions): () => void {
    const id = navigator.geolocation.watchPosition((position) => onFix({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      accuracyMeters: position.coords.accuracy,
      altitudeMeters: position.coords.altitude,
      recordedAt: position.timestamp
    }), (error) => onError(new Error(error.message)), options)
    return () => navigator.geolocation.clearWatch(id)
  }
}
